var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"modal-calculate-creating"},[_c('h3',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.value))]),_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('LoadingDots')],1),_c('div',{attrs:{"slot":"footer"},slot:"footer"})])
}
var staticRenderFns = []

export { render, staticRenderFns }